module.exports = __webpack_public_path__ + "static/media/photograph.8c49172c.jpg";